import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@headlessui/react";
import { LoadingOval } from "../../Loading/Loading";
import { WPQTTooltip } from "../../Tooltip/WPQTTooltip";
var ButtonType;
(function (ButtonType) {
    ButtonType["BUTTON"] = "button";
    ButtonType["SUBMIT"] = "submit";
    ButtonType["RESET"] = "reset";
})(ButtonType || (ButtonType = {}));
function WPQTButton({ onClick = () => { }, btnText, className, type = ButtonType.BUTTON, }) {
    return (_jsx(Button, { className: `wpqt-inline-flex wpqt-cursor-pointer wpqt-items-center wpqt-justify-center wpqt-whitespace-nowrap wpqt-rounded-lg wpqt-border wpqt-border-transparent wpqt-bg-blue-500 wpqt-px-3 wpqt-py-1 wpqt-text-sm/6 wpqt-text-white wpqt-transition-[color,background-color,border-color,text-decoration-color,fill,stroke,box-shadow] focus:wpqt-outline-none focus:wpqt-ring-4 focus:wpqt-ring-blue-800 enabled:hover:wpqt-bg-blue-600 ${className}`, onClick: onClick, type: type, children: btnText }));
}
function WPQTIconButton({ icon, text, onClick = () => { }, className, tooltipId, tooltipText, loading = false, }) {
    const showTooltip = tooltipText && tooltipId;
    const tooltipAttributes = showTooltip
        ? {
            "data-tooltip-id": tooltipId,
            "data-tooltip-content": tooltipText,
            "data-tooltip-position-strategy": "fixed",
            "data-tooltip-variant": "info",
        }
        : {};
    return (_jsxs("div", Object.assign({}, tooltipAttributes, { className: `wpqt-main-border wpqt-relative wpqt-inline-flex wpqt-cursor-pointer wpqt-items-center wpqt-justify-center wpqt-gap-2 wpqt-bg-gray-100 wpqt-p-2 hover:wpqt-bg-white ${className}`, onClick: onClick, children: [icon, text && (_jsx("span", { className: `wpqt-whitespace-nowrap ${loading ? "wpqt-invisible" : ""}`, children: text })), loading && (_jsx(LoadingOval, { width: "20", height: "20", className: "wpqt-absolute wpqt-top-1/2 wpqt-left-1/2 wpqt-transform-y-center wpqt-transform-x-center" })), showTooltip && _jsx(WPQTTooltip, { id: tooltipId })] })));
}
export { ButtonType, WPQTButton, WPQTIconButton };
